import React from "react";
import { Briefcase, User as UserIcon, HelpCircle } from "lucide-react";

/**
 * Fase 2 — Klanttype badge.
 * 3 primaire types met icoon + kleur. Onbekende types vallen terug op grijs.
 */
const TYPE_CONFIG = {
  zakelijk: {
    label: "Zakelijk",
    classes: "bg-[#E6EEFF] text-[#0055FF] border-[#0055FF]/30",
    Icon: Briefcase,
  },
  particulier: {
    label: "Particulier",
    classes: "bg-[#E6F8EE] text-[#0E7A3A] border-[#0E7A3A]/30",
    Icon: UserIcon,
  },
  onbekend: {
    label: "Onbekend",
    classes: "bg-gray-100 text-gray-600 border-gray-300",
    Icon: HelpCircle,
  },
  webshop: {
    label: "Webshop",
    classes: "bg-purple-50 text-purple-700 border-purple-200",
    Icon: Briefcase,
  },
  shop_drop_ship: {
    label: "Shop, Drop & Ship",
    classes: "bg-purple-50 text-purple-700 border-purple-200",
    Icon: Briefcase,
  },
  terugkerend: {
    label: "Terugkerend",
    classes: "bg-blue-50 text-blue-700 border-blue-200",
    Icon: Briefcase,
  },
};

export default function CustomerTypeBadge({ type, size = "default", showIcon = true, testid }) {
  const cfg = TYPE_CONFIG[type] || TYPE_CONFIG.onbekend;
  const { Icon } = cfg;
  const sizeClasses =
    size === "sm"
      ? "px-1.5 py-0.5 text-[10px] gap-1"
      : "px-2 py-0.5 text-xs gap-1.5";
  return (
    <span
      data-testid={testid || `customer-type-badge-${type || "onbekend"}`}
      className={`inline-flex items-center font-chivo font-bold uppercase tracking-wide border ${cfg.classes} ${sizeClasses}`}
    >
      {showIcon && <Icon className={size === "sm" ? "w-3 h-3" : "w-3.5 h-3.5"} />}
      {cfg.label}
    </span>
  );
}

export const CUSTOMER_TYPE_LABELS = Object.fromEntries(
  Object.entries(TYPE_CONFIG).map(([k, v]) => [k, v.label])
);
